import { memo, useMemo } from 'react';
import _get from 'lodash/get';
import { IAppContextStore, useAppContext } from '../../../context/app-context';
import { filterItems } from '../../../helpers/contentful-helper';
import { Entry } from 'contentful';
import { IHeroBanner } from './hero-banner.types';

const HeroBanner: React.FC = () => {
  const { rawContentFul }: IAppContextStore = useAppContext();
  const heroSection: Entry<IHeroBanner> = useMemo(() => (
    filterItems(rawContentFul, 'newHomepageHeroSection')?.[0]
  ) as Entry<IHeroBanner>, [rawContentFul]);

  return (
    <section className='relative flex flex-col md:flex-row md:mt-28'>
      <div className='flex-1 px-4 mb-10 md:min-h-[400px]'>
        <div className='max-w-lg w-full mx-auto'>
          <h1 className='max-w-xs md:max-w-lg text-24 md:text-5xl
            font-bold mt-6 md:mt-10 font-inter leading-8 md:leading-56'>
            {_get(heroSection, 'fields.title', '')}
          </h1>
          <p className='text-16 md:text-18 mt-4 font-sans text-[#666971]'>
            {_get(heroSection, 'fields.subtitle', '')}
          </p>
          <div className='flex justify-start mt-6'>
            <a
              href={_get(heroSection, 'fields.ctaButtonLink', '')}
              className='bg-[#F83D11] text-white px-8 py-4
                text-4 font-bold rounded-[50px] font-sans leading-18'
            >
              {_get(heroSection, 'fields.ctaButtonText', '')}
            </a>
          </div>
        </div>
      </div>
      <div className='relative flex-1 flex items-flex-end'>
        <div className='relative z-[1] w-full flex items-end'>
          <img
            src={_get(heroSection, 'fields.featuredImage.fields.file.url', '')}
            alt={_get(heroSection, 'fields.featuredImage.fields.title', '')}
            className='hidden md:block w-full object-cover object-left'
          />
          <img
            src={_get(heroSection, 'fields.featuredImageMobile.fields.file.url', '')}
            alt={_get(heroSection, 'fields.featuredImageMobile.fields.title', '')}
            className='block md:hidden'
          />
        </div>
        <div className='absolute top-8 md:top-[30%] left-0 right-0 bottom-0 bg-[#F83D11]'/>
      </div>
    </section>
  )
};

export default memo(HeroBanner);
